import { FileUp, Mail } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { InvoiceSource as InvoiceSourceEnum } from "@/apis/gql/types";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { TypographySmall } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

export const InvoiceSource = ({
  source: _source,
  className,
}: {
  source: string;
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
}) => {
  const { t } = useTranslation();

  const source = useMemo(() => {
    // hackity hack
    if (_source.includes("@") || _source.toLowerCase().includes("email")) {
      return {
        label: t("invoice_source.email"),
        icon: Mail,
      };
    }

    // we are not controlling this really well always default to upload
    return {
      label: t("invoice_source.upload"),
      icon: FileUp,
    };
  }, [_source, t]);

  const isEmail =
    _source.includes("@") || _source.toLowerCase().includes("email");

  const content = (
    <div
      className={cn(
        "flex flex-row items-center gap-1 text-primary/90 w-fit",
        className,
      )}
    >
      <source.icon className="w-4 h-4" />
      <TypographySmall>{source.label}</TypographySmall>
    </div>
  );

  if (!isEmail) {
    return content;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild className="cursor-pointer">
          {content}
        </TooltipTrigger>
        <TooltipContent>{_source}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
